import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CONTENT_TYPE } from 'shared/constants/general';
import { readSeriesList } from 'shared/modules/series/actions';
import { Button } from '@mui/material';
import EmptyState from 'shared/_components/empty-state';
import ListContainer from 'shared/components/ListContainer/ListContainer';
import SeriesCreate from '../Series/SeriesCreate/SeriesCreate';
import SeriesListItemDetails from './SeriesListItemDetails';

export default function SeriesList() {
	const dispatch = useDispatch();
	const series = useSelector<any, any[]>((state) => state.series.list);
	const [ready, setReady] = useState(false);

	const [showCreate, setShowCreate] = useState(false);
	const toggleCreateNewSeries = useCallback(() => {
		setShowCreate((s) => !s);
	}, []);

	const init = useCallback(async () => {
		await dispatch(readSeriesList());
		setReady(true);
	}, [dispatch]);

	useEffect(() => {
		init();
	}, [init]);

	return (
		<>
			<ListContainer
				page
				ready={ready}
				title="Series"
				items={series}
				// Add is shown in the header only for a loaded, non-empty list; an empty list has it in the empty state
				actions={ready && series.length ? [{ label: 'Add Series', onClick: toggleCreateNewSeries }] : []}
				emptyState={
					<EmptyState
						title="No series yet"
						description="Create your first series to group related videos and audio."
						action={<Button onClick={toggleCreateNewSeries}>Add Series</Button>}
					/>
				}
				details={SeriesListItemDetails}
				type={CONTENT_TYPE.SERIES}
			/>
			{showCreate && <SeriesCreate onClose={toggleCreateNewSeries} />}
		</>
	);
}
